import axios from "./../../config/axios";

export function getInvoices(params) {
    return axios().get("/sales/invoices", { params })
}
export function simulateInvoice({invoiceId}) {
    return axios().get(`/sales/invoices/${invoiceId}/simulate`);
}

export function postInvoiceToLedger({invoiceId, dpk}) {
    return axios().post(`/sales/invoices/${invoiceId}/post`, {}, { headers: {Dpk: dpk} })
}

export function reverseInvoice(invoiceId) {
    return axios().put(`/sales/invoices/${invoiceId}/reverse`);
}

export default {
    getInvoices,
    simulateInvoice,
    postInvoiceToLedger,
    reverseInvoice
}